<div class="container">
  <div class="content blue">
    <h4>
      <a href="https://csgcommunity.com">csgcommunity.com</a>
    </h4>
    <p>
      Created and maintained a website for a video game community in the summer of 2017 with a redesign in the summer
      of 2018 that utilizes modern technologies to create a Progressive Web Application.
    </p>
  </div>
  <div class="content pink">
    <h4>
      Batch Scripts for <a href="https://github.com/DannyDorito/ARMA-3-Startup-and-Restart-Script">ARMA 3</a> & <a
        href="https://github.com/DannyDorito/DayZ-Startup-and-Restart-Script">DayZ</a> Servers
    </h4>
    <p>
      Restart/crash monitor for ARMA 3 and DayZ.
    </p>
    <p>
      Originally created for the Exile Mod, but can be used for any ARMA 3 Server with an adaptation for DayZ Servers
      too!
    </p>
  </div>
</div>
<div class="container">
  <div class="content pink">
    <h4>
      <a href="https://github.com/Sanjo/npp-sqf">npp-sqf</a>
    </h4>
    <p>
      Contributor to a repo for Notepad++ syntax highlighting and autocompletion for SQF (the scripting language for
      the ARMA video games).
    </p>
  </div>
  <div class="content blue">
    <h4>
      <a href="https://sqm.jallison.co.uk">SQM File Parser and Pre-processor</a>
    </h4>
    <p>
      SQM File Parser and Pre-processor Submitted for the Master of Engineering in Computer Science at the University of
      Hull.
    </p>
  </div>
</div>
